import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import DivContainer from '../../components/DivContainer';
import InputMultiSelectComponent from '../../components/inputs/InputMultiSelectComponent';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import UserModel from '../../model/UserModel';
import UserSummaryService from '../../services/UserSummaryService';
import UserRoleService from '../../services/UserRoleService';
import AccountService from '../../services/AccountService';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import SettingService from '../../services/SettingService';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import PayrollService from '../../services/PayrollService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class PayrollRequestDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new PayrollService());
        this.settingService = new SettingService();
        this.state = {
            element: {
                dateStart: null,
                dateEnd: null,
                users: this.props.users,
                selectAll: this.props.selectAll,
            },
            viewMode: this.props.viewMode,
            activeIndex: 0,
        };
        this.userId = this.authService.getProfile().userId;
        this.userRoleService = new UserRoleService();
        this.userService = new AccountService();

        window.console.log(props);
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    prepareElementBeforeRequest(element) {
        const request = JSON.parse(JSON.stringify(element));
        console.log(request);
        return request;
    }
    initBeforeSetElement() {}
    renderFooter() {
        const footerItems = this.prepareFooterItems();
        if (footerItems !== undefined && footerItems.length > 0 && footerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return (
                <React.Fragment>
                    <hr className='line-footer-user-dialog' />
                    {this.prepareFooter(footerItems)}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    prepareFooterItems() {
        const {viewMode} = this.props;
        return [
            {
                label: t('payroll.dialog.generate'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
            },
            {label: t('details.cancel'), onClick: this.props.onHide, className: 'gray'},
        ];
    }

    handleValidForm() {
        const {element} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .generate(this.state.element)
                .then(() => {
                    console.log('successssss');
                    this.persistMessage('success', '', t('payroll.dialog.generateSuccess'));
                    if (this.props.afterSave) {
                        this.props.afterSave();
                    }
                })
                .catch((err) => {
                    console.log('faillll', err);
                    if (this.props.handleError) {
                        this.props.handleError(err);
                    }
                });
        }
        this.unblockUi();
    }

    renderHeader() {
        const {t, viewMode} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{viewMode === 'NEW' ? t('payroll.dialog.header') : t('user.editHeader')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    getContainerListName() {
        return 'user-summary-list-container';
    }

    getAddSucces() {
        const {t} = this.props;
        return t('user.addUserSuccess');
    }
    getUpdateSucces() {
        return t('user.updateUserSuccess');
    }

    renderDetails() {
        return (
            <Card className='input-card-userdialog'>
                <div className='row align-items-center'>
                    <InputNumberComponent
                        id='limit'
                        name='limit'
                        label={t('payroll.dialog.limit')}
                        colClass='col-lg-12 col-md-12 col-sm-12'
                        value={this.state.element?.limit}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode='NEW'
                        validators='numeric'
                        min={0}
                        mode='currency'
                    />
                    <InputCheckboxComponent
                        id='debitOverLimit'
                        name='debitOverLimit'
                        label={t('payroll.dialog.debitOverLimit')}
                        labelOnRight
                        value={this.state.element.debitOverLimit}
                        validator={this.validator}
                        validators='not_required'
                        colClass='col-lg-12 col-md-12 col-sm-12'
                        //disabled={!this.state.element?.limit > 0}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                    />
                </div>
                <div className='row'>
                    <InputCalendarRangeComponent
                        key={'range'}
                        idFrom={'dateStart'}
                        idTo={'dateEnd'}
                        nameTo={'dateEnd'}
                        nameFrom={'dateStart'}
                        label={''}
                        labelFrom={t('payroll.dialog.dateStart')}
                        labelTo={t('payroll.dialog.dateEnd')}
                        colClass='col-lg-12 col-md-12 col-sm-12'
                        from={this.state.element.dateStart}
                        to={this.state.element.dateEnd}
                        validator={[this.validator, this.validatorDraft]}
                        onChange={this.handleChange}
                        viewMode='NEW'
                        showIcon
                        validatorsTo={`required|date|after_or_equal_datetime~${moment(
                            this.state.element.dateStart ? this.state.element.dateStart : new Date()
                        )
                            .format('DD-MM-YYYY')
                            .toString()}`}
                        placeholderFrom='dd-mm-rrrr'
                        placeholderTo='dd-mm-rrrr'
                        validateViewMode
                        dateFormatMoment='DD-MM-YYYY'
                        validatorsToType='after_or_equal_datetime'
                    />
                </div>
            </Card>
        );
    }
}

PayrollRequestDialog.defaultProps = {
    selectAll: undefined,
    users: undefined,
    visible: false,
    stationId: undefined,
    changePackageUrl: '/change-package',
    saveLabel: 'Generuj',
};

PayrollRequestDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    changePackageUrl: PropTypes.string,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    selectAll: PropTypes.bool,
    users: PropTypes.array,
    saveLabel: PropTypes.string,
};

export default withRouter(withTranslation()(PayrollRequestDialog));
